import React, { useEffect } from 'react';
import { Form, Input, message, Modal } from 'antd';
import { createSkillVersion, getSkillVersionDetail, updateSkillVersion, switchSkillVersion, SkillVersionVo } from '@/api/skill';

export interface EditSkillVersionProp {
  skillId: number;
  data?: SkillVersionVo;
  isEdit?: boolean;
  isFirstVersion?: boolean; // 是否是第一个版本
  updateFn: () => void;
  onCancel: () => void;
}

const SKILL_TEMPLATE = `---
name: Skill名称
description: Skill描述
triggerKeywords:
  - 关键词1
  - 关键词2
toolsConfig:
  - toolCode: Tool编码
    description: Tool用途描述
---

## 触发条件

描述何时触发此Skill。

## 工具链路

描述使用的工具及调用流程。

## 退路策略

描述无法完成任务时的处理方式。
`;

const EditSkillVersion = ({ skillId, data, isEdit, isFirstVersion, updateFn, onCancel }: EditSkillVersionProp) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (isEdit && data?.id) {
      setLoading(true);
      getSkillVersionDetail(data.id)
        .then(res => form.setFieldsValue(res))
        .finally(() => setLoading(false));
    } else {
      form.setFieldsValue({ content: SKILL_TEMPLATE });
    }
  }, [data?.id, isEdit, form]);

  const onFinish = () => {
    form.validateFields().then(values => {
      const params = { ...values, skillId, id: isEdit ? data?.id : undefined };
      const api = isEdit ? updateSkillVersion : createSkillVersion;
      setLoading(true);
      api(params as any).then((res: any) => {
        message.success('保存成功');
        // 如果是第一个版本，自动应用
        if (!isEdit && isFirstVersion && res) {
          const versionId = res.id || res;
          if (versionId) {
            switchSkillVersion({ skillId, versionId }).then(() => {
              message.success('已自动应用为当前版本');
            });
          }
        }
        onCancel();
        updateFn();
      }).finally(() => setLoading(false));
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑版本' : '新增版本'}
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
      width={800}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        {!isEdit && (
          <Form.Item name="version" label="版本号" rules={[{ required: true, message: '请输入版本号' }]}>
            <Input placeholder="如 v1.0.0" />
          </Form.Item>
        )}
        <Form.Item
          name="content"
          label="SKILL.md 内容"
          rules={[{ required: true, message: '请输入 SKILL.md 内容' }]}
          extra="使用 YAML frontmatter + Markdown 格式"
        >
          <Input.TextArea
            rows={18}
            placeholder="SKILL.md 格式内容"
            style={{ fontFamily: 'monospace', fontSize: 13 }}
          />
        </Form.Item>
        <Form.Item name="changeLog" label="变更说明">
          <Input.TextArea rows={3} placeholder="本次版本的变更说明" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditSkillVersion;